module.exports = ".boldText {\r\n    font-weight:bold;\r\n}\r\n\r\ntable th\r\n{\r\n    text-align:left;\r\n}\r\n\r\ntable td{\r\n    text-align: left;\r\n}"